import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getInDocuments } from "../../redux/actions/actioninDocument";
import InDocumentCard from "./inDocumentsCard";
import LoadingIcons from "react-loading-icons";

export default function InDocument() {
  const inDocuments = useSelector((state) => state.inDocuments.allInDocuments);
  const dispatch = useDispatch();
  const [clientFind, setClientFind] = useState();
  const [clientInput, setClientInput] = useState("");

  useEffect(() => {
    dispatch(getInDocuments());
  }, [dispatch]);

  console.log(inDocuments);

  const handleChange = (e) => {
    const { value } = e.target;
    setClientInput(value);
  };

  const filterClient = () => {
    console.log(clientInput);
    if (clientFind === undefined) {
      let result = inDocuments[0].filter((e) => {
        if (
          e.client_id[0].name
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) ||
          e.client_id[0].lastName
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) ||
          e.client_id[0].nameCompany
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) || (
            e.document_id && e.document_id.numberDocument === parseInt(clientInput) )
          
        ) {
          console.log(e);
          return e;
        }
      });
      setClientFind(result);
    } else {
      let result = clientFind.filter((e) => {
        if (
          e.client_id[0].name
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) ||
          e.client_id[0].lastName
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) ||
          e.client_id[0].nameCompany
            .toString()
            .toLowerCase()
            .includes(clientInput.toLowerCase()) || (
            e.document_id && e.document_id.numberDocument === parseInt(clientInput) )
        ) {
          //console.log(e)
          return e;
        }
      });
      setClientFind(result);
    }
  };

  const handleLimpiar = () => {
    console.log(clientFind);
    setClientFind(inDocuments[0]);
  };

  return (
    <div className="container bg-gray-900">
      <div>
        <div>
          <p className="text-[20pt] h-10 ml-2 mt-4 pb-8 underline text-orange-500 ">
            Remitos Entrada - Informes
          </p>
        </div>
        <div className="h-24 pl-2 pt-2 mt-4 bg-cyan-900  ">
          <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="Nombre Cliente"
              onChange={handleChange}
            />
          </div>
          <div className="w-56 text-center">
            <button
              className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]"
              onClick={filterClient}
            >
              Buscar
            </button>
            <button
              className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]"
              onClick={handleLimpiar}
            >
              Limpiar
            </button>
          </div>
        </div>
        <div className="flex flex-row text-[14px] font-bold   text-orange-500">
          <div className="w-16 text-center">Doc N°</div>
          <div className="w-72">Cliente</div>
          <div className="w-28 text-center">Fecha de Recepción</div>
          <div className="w-20 text-center">Remito Asociado</div>
        </div>

        <div>
        {inDocuments.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
          clientFind === undefined
            ? inDocuments[0].map((e) => (
                <InDocumentCard
                  key={e._id}
                  id={e._id}
                  numberDocument={e.numberDocument}
                  client_id={
                    e.client_id[0] !== undefined
                      ? e.client_id[0].nameCompany
                      : "-"
                  }
                  numberDocOut={e.document_id && e.document_id.numberDocument}
                  numberDocOutId={e.document_id && e.document_id._id}
                  dateReception={e.dateReception}
                />
              ))
            : clientFind.map((e) => (
                <InDocumentCard
                  key={e._id}
                  id={e._id}
                  numberDocument={e.numberDocument}
                  client_id={
                    e.client_id[0] !== undefined
                      ? e.client_id[0].nameCompany
                      : "-"
                  }
                  numberDocOut={e.document_id && e.document_id.numberDocument}
                  numberDocOutId={e.document_id && e.document_id._id}
                  dateReception={e.dateReception}
                />
              ))}
        </div>
      </div>
    </div>
  );
}
